export const calculateDaysBetweenDates = (
  timeStamp1: number,
  timeStamp2: number
) => {
  if (timeStamp1 !== 0) {
    const timeStampResult = timeStamp1 - timeStamp2
    const days = Math.ceil(timeStampResult / (1000 * 60 * 60 * 24))
    return days
  }
  return 0
}
